import React from 'react';
import { Link } from 'react-router-dom';

import { TextDisplay } from 'uikit/Text';
import routes from '../../../utils/routeTranslator';
import { TGroupedCities } from '../CategoryCities.helpers';

import './CategoryRegion.scss';

type CategoryRegion$Props = {
  region: TGroupedCities;
  categorySlug: string;
  isL2?: boolean;
};

export default function CategoryRegion({ region, categorySlug, isL2 }: CategoryRegion$Props) {
  const routeName = isL2 ? 'front::categories.type' : 'front::category';

  return (
    <div className="categoryRegion">
      <TextDisplay className="categoryRegion__region">{region.region.name}</TextDisplay>
      <ul className="categoryRegion__cities">
        {region.cities.map((city) => (
          <li className="categoryRegion__city" key={city.slug}>
            <Link to={routes.get(routeName, { slug: categorySlug, city: city.slug })}>{city.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
